export const MAX_AUTO_WITHDRAW_TIME_IN_MINUTES = 24 * 60
